export const formatId = (id) => {
    // Convert the number to a string and pad with zeros to ensure a total length of 6 characters
    return `PLHC${id.toString().padStart(6, '0')}`;
};